import React, { Component } from 'react';
import {
  notification,
  Modal,
  Select,
  Button,
  Row,
  Col,
  Input,
  Table,
  Popover,
  Switch,
} from 'antd/lib';

import moment from 'moment';
import { withApollo, graphql, compose } from 'react-apollo';
import asignarOficioSalida from '../../../graphql/mutations/registroEntradaSalida/asignarOficioSalida.graphql';
import asignarDocumentoSalida from '../../../graphql/mutations/registroEntradaSalida/asignarDocumentoSalida.graphql';
import getOficiosPorNumero from '../../../graphql/querys/tramites/getOficiosPorNumero.graphql';
import getDocumentosCasoViolencia from '../../../graphql/querys/violenciaGenero/getDocumentosCasoViolencia.graphql';
import { errorService } from '../../../graphql/utils/utils';

const Option = Select.Option;
const Search = Input.Search;

@compose(
  graphql(asignarOficioSalida, { name: 'asignarOficioSalida' }),
  graphql(asignarDocumentoSalida, { name: 'asignarDocumentoSalida' })
)
class ModalAsignarOficio extends Component {
  state = {
    numero: null,
    loading: false,
    oficiosEncontrados: [],
    documentosViolencia: [],
    buscarOficios: true,
  };

  crearOpciones = articulo => {
    return (
      <Option key={articulo._id} value={articulo._id}>
        {articulo.nombre}
      </Option>
    );
  };

  buscarOficios = numero => {
    this.props.client
      .query({
        query: getOficiosPorNumero,
        variables: {
          numero: numero,
        },
      })
      .then(respuesta => {
        if (
          respuesta.data.getOficiosPorNumero &&
          respuesta.data.getOficiosPorNumero.length > 0
        ) {
          console.log(respuesta.data.getOficiosPorNumero);
          notification.info({
            message: 'Documentos Independientes Encontrados!',
          });
          this.setState({
            ...this.state,
            oficiosEncontrados: respuesta.data.getOficiosPorNumero,
          });
        } else {
          notification.warning({
            message:
              'No se encontraron Documentos Independientes con ese numero',
          });
        }
      })
      .catch(error => {
        console.log(
          'Error a la hora de buscar el documento independiente por un numero: ',
          error
        );
        errorService(error, {
          numero: numero,
        });
      });
  };

  asignarOficio = idOficio => {
    this.props
      .asignarOficioSalida({
        variables: {
          _id: this.props._id,
          idOficioSalida: idOficio,
        },
      })
      .then(respuesta => {
        if (respuesta.data.asignarOficioSalida) {
          notification.success({
            message: 'Asignacion del documento realizada correctamente!',
          });
          this.props.ocultarModalAsignar();
        }
      })
      .catch(err => {
        console.log('ERROR A LA HORA DE ASIGNAR UN DOCUMENTO A UN REGISTRO');
        console.log(err);
      });
  };

  buscarDocumentos = numeroCaso => {
    this.props.client
      .query({
        query: getDocumentosCasoViolencia,
        variables: {
          numero: numeroCaso,
        },
      })
      .then(respuesta => {
        if (
          respuesta.data.getDocumentosCasoViolencia &&
          respuesta.data.getDocumentosCasoViolencia.length > 0
        ) {
          console.log(respuesta.data.getDocumentosCasoViolencia);
          notification.info({
            message: 'Documentos de Violencia Encontrados!',
          });
          this.setState({
            ...this.state,
            documentosViolencia: respuesta.data.getDocumentosCasoViolencia,
          });
        } else {
          notification.warning({
            message:
              'No se encontraron Documentos de Violencia con ese numero de caso',
          });
        }
      })
      .catch(error => {
        console.log(
          'Error a la hora de buscar el caso de violencia por un numero: ',
          error
        );
        errorService(error, {
          numero: numeroCaso,
        });
      });
  };

  asignarDocumento = idDocumento => {
    this.props
      .asignarDocumentoSalida({
        variables: {
          _id: this.props._id,
          idDocumentoSalida: idDocumento,
        },
      })
      .then(respuesta => {
        if (respuesta.data.asignarDocumentoSalida) {
          notification.success({
            message: 'Asignacion del documento realizada correctamente!',
          });
          this.props.ocultarModalAsignar();
        }
      })
      .catch(err => {
        console.log('ERROR A LA HORA DE ASIGNAR UN DOCUMENTO A UN REGISTRO');
        console.log(err);
        errorService(err, {
          _id: this.props._id,
          idDocumentoSalida: idDocumento,
        });
      });
  };

  render() {
    const columns = [
      {
        title: 'Numero',
        dataIndex: 'numero',
        key: 'numero',
      },
      {
        title: 'Nombre',
        dataIndex: 'nombre',
        key: 'nombre',
        render: nombre => (
          <Popover content={nombre} title="Nombre">
            {nombre.length > 30 ? nombre.slice(0, 30).concat('...') : nombre}
          </Popover>
        ),
      },
      {
        title: 'Fecha Creacion',
        dataIndex: 'fechaCreacion',
        key: 'fechaCreacion',
        render: fecha => moment(fecha).format('DD/MM/YYYY'),
      },
      {
        title: 'Acciones',
        key: 'action',
        render: (text, record) => (
          <Button type="primary" onClick={() => this.asignarOficio(record._id)}>
            Elegir
          </Button>
        ),
      },
    ];

    return (
      <div>
        <Modal
          title="Asignar"
          visible={this.props.visibleAsignarOficio}
          onCancel={this.props.ocultarModalAsignar}
          width={800}
          style={{ width: 600 }}
          footer={[
            <Button key="back" onClick={this.props.ocultarModalAsignar}>
              Volver
            </Button>,
          ]}
        >
          <Col>
            <Row gutter={[0, 16]}>
              <Col offset={8} span={12}>
                <Switch
                  checked={this.state.buscarOficios}
                  checkedChildren="Buscar Documentos Independientes"
                  unCheckedChildren="Buscar Documentos de Caso Violencia"
                  onChange={checked =>
                    this.setState({ buscarOficios: checked })
                  }
                />
              </Col>
            </Row>
            {this.state.buscarOficios && (
              <div>
                <Row>
                  <Col span={8}>
                    <h4>Numero del oficio:</h4>
                  </Col>
                  <Col span={14}>
                    <Search
                      placeholder="Ingrese el numero del documento independiente"
                      onSearch={this.buscarOficios}
                      enterButton
                    />
                  </Col>
                </Row>
                <Row style={{ marginTop: 10 }}>
                  <Col span={16} offset={4}>
                    <Table
                      rowKey="_id"
                      columns={columns}
                      pagination={false}
                      dataSource={this.state.oficiosEncontrados}
                    />
                  </Col>
                </Row>
              </div>
            )}
            {!this.state.buscarOficios && (
              <div>
                <div>
                  <Row>
                    <Col span={8}>
                      <h4>Numero del caso de violencia:</h4>
                    </Col>
                    <Col span={14}>
                      <Search
                        placeholder="Ingrese el numero del caso de violencia"
                        onSearch={this.buscarDocumentos}
                        enterButton
                      />
                    </Col>
                  </Row>
                  <Row style={{ marginTop: 10 }}>
                    <Col span={16} offset={4}>
                      <Table
                        rowKey="_id"
                        pagination={false}
                        columns={[
                          {
                            title: 'Nombre',
                            dataIndex: 'nombre',
                            key: 'nombre',
                            render: nombre => (
                              <Popover content={nombre} title="Nombre">
                                {nombre.length > 70
                                  ? nombre.slice(0, 70).concat('...')
                                  : nombre}
                              </Popover>
                            ),
                          },
                          {
                            title: 'Fecha Creacion',
                            dataIndex: 'fechaCreacion',
                            key: 'fechaCreacion',
                            render: fecha => moment(fecha).format('DD/MM/YYYY'),
                          },
                          {
                            title: 'Acciones',
                            key: 'action',
                            render: (text, record) => (
                              <Button
                                type="primary"
                                onClick={() =>
                                  this.asignarDocumento(record._id)
                                }
                              >
                                Elegir
                              </Button>
                            ),
                          },
                        ]}
                        dataSource={this.state.documentosViolencia}
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            )}
          </Col>
        </Modal>
      </div>
    );
  }
}

export default withApollo(ModalAsignarOficio);
